import React from 'react';
import { Box, IconButton } from '@mui/material';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faListUl } from '@fortawesome/pro-regular-svg-icons';
import { faArrowLeft, faArrowRight } from '@fortawesome/pro-light-svg-icons';
import MssTooltip from '../common/MssTooltip';

/**
 * The bar every quiz page pins to the bottom of a phone screen: the question
 * list on the left, back and forward on the right.
 *
 * A phone shows one question at a time, so these are the only way through a
 * quiz. They sit in the page rather than floating over it — the questions
 * scroll underneath and the controls stay put, without a floating button
 * covering the answer beneath it.
 *
 * Props:
 *   id         (string)   - ID prefix for generated element IDs.
 *   index      (number)   - Zero-based position of the question on screen.
 *   total      (number)   - How many questions the quiz has.
 *   onChange   (function) - Called with the index to move to.
 *   onOpenList (function) - Show the question list.
 */
export const QuizMobileBar = ({ id, index, total, onChange, onOpenList }) => (
  <Box className="mss__quizMobileBar" id={`${id}__mobileBar`}>
    <IconButton
      id={`${id}__button_questionList`}
      className="questionListButton"
      onClick={onOpenList}
      aria-label="Open question list"
    >
      <FontAwesomeIcon icon={faListUl} />
    </IconButton>

    <Box className="quizPager">
      {/* Wrapped in a span so the tooltip still fires on hover once the button
          disables at either end of the quiz — as the study deck's pager does. */}
      <MssTooltip id={`${id}__tooltip_previousQuestion`} title="Previous question">
        <span>
          <IconButton
            id={`${id}__button_previousQuestion`}
            className="pagerButton"
            onClick={() => onChange(index - 1)}
            disabled={index === 0}
            aria-label="Previous question"
          >
            <FontAwesomeIcon icon={faArrowLeft} />
          </IconButton>
        </span>
      </MssTooltip>

      {/* Forward is never held back by an unanswered question — only Submit is. */}
      <MssTooltip id={`${id}__tooltip_nextQuestion`} title="Next question">
        <span>
          <IconButton
            id={`${id}__button_nextQuestion`}
            className="pagerButton"
            onClick={() => onChange(index + 1)}
            disabled={index >= total - 1}
            aria-label="Next question"
          >
            <FontAwesomeIcon icon={faArrowRight} />
          </IconButton>
        </span>
      </MssTooltip>
    </Box>
  </Box>
);
